export default {
    // 基础配置
    "base": {
        "mode": "1",
        "labelWidth": "70px",//搜索框左侧标题宽度
        "select": false,//是否有批量选择
        "sortBy": "id",//默认排序字段
        "desc": true,//默认排序规则
        "order": false,//是否增加第一列为ID
        "pageSize": 10,//每页多少条
        "isShowTable": true
    },
    // el-talbe属性（官网有的基本都支持）
    "table": {
        "style": {
            "width": "100%"
        },
        "stripe": true,
        "cell-style": {
            "padding": "7px 0"
        },
        "border": false,
        "header-cell-style": {
            "background": "#2f314f17",
            "padding": "5px 0"
        }
    },
    // 搜索模块
    /**
     * type：0，搜索按钮
     * type：1，关键词搜索
     * type：2，下拉框单选
     * type：3，下拉框多选
     * type：4，日期选择
     * type：5，日期范围
     * type：6，关键词搜索，样式2
     * type：99，自定义
     */
    "search": [],
    // 展示列模块，属性也基本上兼容ele官网所有属性
    "props": []
}